import underscored from 'underscore.string/underscored';

interface ContactBadgeClassProps {
  type: string;
  status: string;
}

const contactBadgeClass = ({ type, status }: ContactBadgeClassProps) => {
  const t = underscored(type);
  const s = underscored(status);

  switch (true) {
    case t === 'prospect':
      return 'prospect-badge';
    case t === 'non_attending_contact' || s === 'not_attending':
      return 'non-attending-contact-badge';
    case t === 'member' && s === 'active':
      return 'member-badge';
    case t === 'member' && s === 'cancelled':
      return 'cancelled-badge';
    case t === 'member' && s === 'suspended':
      return 'suspended-badge';
  }
};

export default contactBadgeClass;
